<template>
    <DFormRow
        :label="__('products.productPrices.form.billing_cycle')"
        :is-required="true"
        :error="errors.billing_cycle"
    >
        <DSelect
            :id="`billing_cycle${idSuffix}`"
            :model-value="modelValue"
            :options="billingCycleOptions"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'BillingCycle',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        idSuffix: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue'],
    computed: {
        billingCycleOptions () {
            return [{ label: '', value: '' }, ...this.billingCycles]
        }
    }
}
</script>
